import { jsx as C } from "react/jsx-runtime";
const l = () => /* @__PURE__ */ C(
  "path",
  {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.25 4.5C6.25 3.25736 7.25736 2.25 8.5 2.25H15.5C16.7426 2.25 17.75 3.25736 17.75 4.5V19.5C17.75 20.7426 16.7426 21.75 15.5 21.75H8.5C7.25736 21.75 6.25 20.7426 6.25 19.5V4.5ZM9.75 5.5C9.75 5.08579 10.0858 4.75 10.5 4.75H13.5C13.9142 4.75 14.25 5.08579 14.25 5.5C14.25 5.91421 13.9142 6.25 13.5 6.25H10.5C10.0858 6.25 9.75 5.91421 9.75 5.5ZM12 19C12.5523 19 13 18.5523 13 18C13 17.4477 12.5523 17 12 17C11.4477 17 11 17.4477 11 18C11 18.5523 11.4477 19 12 19Z",
    fill: "currentColor"
  }
);
export {
  l as default
};
